import RoutedTabs from '@/components/RoutedTabs';
import React from 'react';

export default function GuidelinesTreatmentIndex() {
  const tabs = [
    { name: 'Guidelines', path: 'guidelines' },
    {
      name: 'Templates',
      path: 'templates',
    },
  ];

  return (
    <div className="h-2/3">
      <div className="flex items-center my-3">
        <h1 className="ml-1 text-3xl font-semibold">Guidelines</h1>
      </div>
      <RoutedTabs pathPrefix="/behavior-config/" tabs={tabs} />
    </div>
  );
}
